module.exports = __webpack_public_path__ + "static/9-korter-eb6ab963a0441c0721814f2f5138b951.jpg";